interface BaseLoyaltyCampaignOffer {
  title: string
  description: string
  link: string
  imageId: string
  /** If specified, offer only shows in these regions. If omitted, shows in all regions. */
  regions?: Array<string>
}

/**
 * Campaign offer controlled by custom rule (shows only when rule is active)
 * Can specify multiple rule IDs (e.g., one for staging, one for prod)
 */
interface RuleBasedCampaignOffer extends BaseLoyaltyCampaignOffer {
  customRuleIds: Array<string>
}

/**
 * Campaign offer that is always enabled (not tied to custom rules)
 */
interface AlwaysEnabledCampaignOffer extends BaseLoyaltyCampaignOffer {
  forceEnable: true
}

export type LoyaltyCampaignOffer = RuleBasedCampaignOffer | AlwaysEnabledCampaignOffer

export const LOYALTY_CAMPAIGN_OFFERS: Array<LoyaltyCampaignOffer> = [
  {
    title: 'Double Status Credits on hotel stays',
    description: 'Stay somewhere special and get rewarded twice. Book one of our curated hotel escapes and earn Double Status Credits. Ending 24 December 2025.',
    link: '/hotels',
    imageId: 'ejtmomf9dsndnxz99v',
    customRuleIds: [
      '4e5b3afe-ad26-4324-9972-6c4c982dca95',
      'c170c9d8-e79d-4005-aa56-6f8bc1aafd3b',
    ],
  },
  {
    title: 'Double Status Credits on handpicked tours',
    description: 'Go beyond the ordinary with immersive, expertly curated tours. From ancient wonders to cultural deep-dives, enjoy Double Status Credits as you discover the world. Ending 24 December 2025.',
    link: '/tours',
    imageId: 'bv02lcvv3svuoiezez',
    customRuleIds: [
      '4e5b3afe-ad26-4324-9972-6c4c982dca95',
      'c170c9d8-e79d-4005-aa56-6f8bc1aafd3b',
    ],
  },
  {
    title: 'Double Status Credits on cruise bookings',
    description: 'Set sail in style and unlock your next status tier faster. Book from our exclusive cruise collection and earn Double Status Credits on every journey. Ending 24 December 2025.',
    link: '/cruises',
    imageId: 'fnkxq89apjdnklxifg',
    customRuleIds: [
      '4e5b3afe-ad26-4324-9972-6c4c982dca95',
      'c170c9d8-e79d-4005-aa56-6f8bc1aafd3b',
    ],
  },
  {
    title: 'Triple Société Points on every Shop purchase',
    description: 'Enjoy 3× points on all products from the Luxury Escapes Shop this month. Ending 24 December 2025.',
    link: '/shop',
    imageId: 'rud239l2q5j81e8v5uob',
    regions: ['AU'],
    customRuleIds: [
      '1474f4db-ed16-47e9-8696-03f9f31cf606',
    ],
  },
  {
    title: 'Triple Points on Garuda Airways',
    description: 'Skip the queue with 24/7 access to our dedicated support team, always here to help, whenever you need us.',
    link: '/flights',
    imageId: 'rj8rmpfex9caygh3g1',
    customRuleIds: [
    ],
  },
  {
    title: 'Double Points on Ultra Lux escapes',
    description: 'When only the best will do. Book from our Ultra Lux collection and earn Double Points.',
    link: '/ultra-lux',
    imageId: 'gkc3cki0fnhpxzswubv',
    customRuleIds: [
      '628c9023-0529-4547-beba-f101928245cf',
      // prod rule id
      'bdfe3e73-b208-4d20-9d36-ef1a64c65945',
    ],
  },
]
